import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Radio,
  RadioGroup,
  FormLabel,
  Autocomplete,
  FormControl,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";
import { formatDate } from "../../../Utils/DateAndTime";

function ProjectTeamMemberForm() {

  const navigate = useNavigate();
  const { id } = useParams(); // if id is present => edit mode
  const mode = id ? "edit" : "add";

  const { userData } = useAuthStore();

  console.log("full uer data is : ", userData);

  const org = userData?.organization;

  const fetchClientContactData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/project-team-members/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;
      if (data) {
        // Detect person type from existing data
        const personTypeId = data.organization_person?.person_type_id;
        if (personTypeId) {
          setSelectedPersonType(String(personTypeId));
        }

        const projectId = data.organization_project_id || "";
        
        setFormData({
          organization_id: data.organization_id || "",
          organization_project_id: projectId,
          organization_entity_id: data.organization_entity_id || "",
          organization_project_team_id: data.organization_project_team_id || "",
          organization_person_id: data.organization_person_id || "",
          organization_user_role_id: data.organization_user_role_id || "",
          is_team_lead: data.is_team_lead || false,
          joining_date: formatDate(data.joining_date) || ""
        });

        // Fetch teams for the selected project in edit mode
        if (projectId) {
          fetchTeams(projectId);
        }
      }
    } catch (error) {
      toast.error("Failed to fetch client data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mode === "edit" && id) {
      fetchClientContactData();
    }
  }, [mode, id]);

  const [formData, setFormData] = useState({
    organization_id: org?.organization_id || "",
    organization_entity_id: "",
    organization_project_id: "",
    organization_project_team_id: "",
    organization_person_id: "",
    organization_user_role_id: "",
    is_team_lead: false,
    joining_date: ""
  });

  const [selectedPersonType, setSelectedPersonType] = useState("1"); // Default to Employee (1)
  const [allPersons, setAllPersons] = useState([]); // Store all persons

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {
    const errors = {};

    if (!formData.organization_project_team_id)
      errors.organization_project_team_id = "Team is required";

    if (!formData.organization_person_id)
      errors.organization_person_id = "Employee is required";

    if (formData.joining_date) {
      const today = new Date();
      const joiningDate = new Date(formData.joining_date);

      // Reset time to 00:00:00 for accurate comparison
      today.setHours(0, 0, 0, 0);
      joiningDate.setHours(0, 0, 0, 0);

      if (joiningDate > today) {
        errors.joining_date = "Joining Date cannot be in the future";
      }
    }

    console.log("err ; ", errors);

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const [selectOptions, setSelectOptions] = useState({
    Projects: [],
    Teams: [],
    Employees: [],
  })

  const fetchProjects = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/projects`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      console.log("response Projects is : ", response);

      setSelectOptions((prev) => ({ ...prev, Projects: response.data.data }));
    } catch (e) {
      console.error("Failed to load Projects");
    }
  };

  const fetchTeams = async (project_id) => {
    if (!project_id || !org?.organization_id) {
      // Clear teams if no project selected or org not available
      setSelectOptions((prev) => ({ ...prev, Teams: [] }));
      return;
    }

    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-teams`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org.organization_id,
          project_id: project_id
        },
      });

      console.log("response ProjectTeams is : ", response);

      // Handle both direct array and paginated response
      const teams = Array.isArray(response.data.data) 
        ? response.data.data 
        : (response.data.data?.data || []);

      console.log("Teams loaded:", teams.length, teams);
      setSelectOptions((prev) => ({ ...prev, Teams: teams }));
    } catch (e) {
      console.error("Failed to load ProjectTeams", e);
      setSelectOptions((prev) => ({ ...prev, Teams: [] }));
    }
  };

  const fetchEmployeesOfOrg = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/organizations/${org.organization_id}/persons-data-all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      // Store all persons
      setAllPersons(response.data.persons || []);
      
      // Filter and sort based on selected person type
      filterPersonsByType(response.data.persons || [], selectedPersonType);
    } catch (e) {
      console.error("Failed to load Employees");
    }
  };

  // Filter persons based on selected person type
  const filterPersonsByType = (persons, personType) => {
    const filteredPersons = persons.filter(
      (person) => Number(person.organization_person?.person_type_id) === Number(personType)
    );

    const sortedEmps = [...filteredPersons].sort((a, b) =>
      (`${a.first_name} ${a.last_name} - ${a.organization_person?.person_code}` || "").localeCompare(`${b.first_name} ${b.last_name} - ${b.organization_person?.person_code}` || "")
    );

    setSelectOptions((prev) => ({ ...prev, Employees: sortedEmps }));
  };

  // Handle person type change
  const handlePersonTypeChange = (e) => {
    const newPersonType = e.target.value;
    setSelectedPersonType(newPersonType);
    
    // Reset selected employee when person type changes
    setFormData((prev) => ({ ...prev, organization_person_id: "" }));
    
    // Filter persons based on new type
    filterPersonsByType(allPersons, newPersonType);
  };

  useEffect(() => {if(org?.organization_id){fetchProjects();
    fetchEmployeesOfOrg();}
    
  }, [org?.organization_id]);

  useEffect(() => {
    if (formData.organization_project_id) {
      fetchTeams(formData.organization_project_id);
    }
  }, [formData.organization_project_id]);

  // Filter employees when person type or allPersons changes
  useEffect(() => {
    if (allPersons.length > 0) {
      filterPersonsByType(allPersons, selectedPersonType);
    }
  }, [selectedPersonType, allPersons.length]);

  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    let organization_entity_id = userData?.organization?.
      entities?.organization_entity_id || null;
    console.log("organization_entity_id is : ", organization_entity_id);
    setBtnLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (mode === "edit") {
        await axios.put(`${MAIN_URL}/api/project-management/project-team-members/${id}`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Team Member updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/project-team-members`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Team Member added");
      }

      navigate("/project-team-member");
    } catch (err) {
      if (err.response?.status === 422) {
        toast.error("Please fix the validation errors.");
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };


  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // If project changes, reset team selection
    if (name === "organization_project_id") {
      setFormData((prev) => ({ 
        ...prev, 
        [name]: value,
        organization_project_team_id: "" // Reset team when project changes
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
    
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };


  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={" Team Member"}
        addMessage={" Team Member"}
        homeLink={"/project-team-member"}
        homeText={"Team Member"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>

                {/* Person Type Selection */}
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Person Type *</FormLabel>
                    <RadioGroup
                      row
                      value={selectedPersonType}
                      onChange={handlePersonTypeChange}
                    >
                      <FormControlLabel value="1" control={<Radio />} label="Employee" />
                      <FormControlLabel value="2" control={<Radio />} label="Intern" />
                    </RadioGroup>
                  </FormControl>
                </Grid>

            

<Autocomplete
  fullWidth
  options={selectOptions?.Projects || []}
  getOptionLabel={(option) => option.project_name || ""}
  value={
    selectOptions?.Projects?.find(
      (p) => p.organization_project_id === formData.organization_project_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_id: newValue ? newValue.organization_project_id : "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project *"
      error={!!formErrors.organization_project_id}
      helperText={formErrors.organization_project_id}
    />
  )}
/>


               

<Autocomplete
  fullWidth
  disabled={selectOptions?.Teams.length === 0}
  options={selectOptions?.Teams || []}
  getOptionLabel={(option) => option.project_team_name || ""}
  value={
    selectOptions?.Teams?.find(
      (team) => team.organization_project_team_id === formData.organization_project_team_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_team_id: newValue ? newValue.organization_project_team_id : "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Team *"
      error={!!formErrors.organization_project_team_id}
      helperText={formErrors.organization_project_team_id}
    />
  )}
/>


             

<Autocomplete
  fullWidth
  disabled={!selectOptions?.Employees?.length}
  options={selectOptions?.Employees || []}
  getOptionLabel={(option) => {
    const firstName = option.first_name || "";
    const lastName = option.last_name || "";
    const personCode = option.organization_person?.person_code || "";
    return personCode ? `${firstName} ${lastName} : ${personCode}` : `${firstName} ${lastName}`;
  }}
  value={
    selectOptions?.Employees?.find(
      (emp) => emp.organization_person?.organization_person_id === formData.organization_person_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_person_id: newValue?.organization_person?.organization_person_id || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label={selectedPersonType === "1" ? "Employee *" : "Intern *"}
      error={!!formErrors.organization_person_id}
      helperText={formErrors.organization_person_id}
    />
  )}
/>


                <TextField
                  fullWidth
                  // select
                  disabled
                  label="User Role"
                  name="organization_user_role_id"
                  value={formData.organization_user_role_id}
                  onChange={handleChange}
                  error={!!formErrors.organization_user_role_id}
                  helperText={"Not Required as of Now"}
                >
                  {/* {selectOptions?.Employees?.map((emp) => (
                    <MenuItem key={emp.organization_user_role_id} value={emp.organization_user_role_id}>
                      {`${emp.first_name} : ${emp.employee_code}`}
                    </MenuItem>
                  ))} */}
                </TextField>

                <TextField
                  fullWidth
                  label="Joining Date "
                  name="joining_date"
                  type="date"
                    
                  InputLabelProps={{ shrink: true }}
                  value={formData.joining_date}
                  onChange={handleChange}
                  error={!!formErrors.joining_date}
                  helperText={formErrors.joining_date}
                />

                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="is_team_lead"
                        checked={formData.is_team_lead}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            is_team_lead: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Is Team Lead"
                  />
                </FormGroup>

                {/* <TextField
                  fullWidth
                  select
                  label="Is Team Lead"
                  name="is_team_lead"
                  value={formData.is_team_lead}
                  onChange={handleChange}
                  error={!!formErrors.is_team_lead}
                  helperText={formErrors.is_team_lead}
                >
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </TextField> */}

                {/* <TextField
                  fullWidth
                  select
                  label="Is Active"
                  name="is_active"
                  value={formData.is_active}
                  onChange={handleChange}
                  error={!!formErrors.is_active}
                  helperText={formErrors.is_active}
                >
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </TextField> */}

              </Grid>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleSubmit}
                disabled={loading || btnLoading}
                sx={{
                  borderRadius: 2, 
                  minWidth: 120,
                  textTransform: "capitalize",
                  fontWeight: 500,
                  mt: 2
                }}
              >
                {loading || btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : mode === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default ProjectTeamMemberForm
